<template>
  <div class="c-map-search-field">
    <cool-select
      v-model="selected_location"
      :items="geo_items"
      :loading="geo.loading"
      item-text="name"
      placeholder="Département, Commune"
      disable-filtering-by-search
      @search="onGeoSearch"
      @select="onGeoSelect"
    >
      <template slot="item" slot-scope="{ item: location }">
        <div v-if="location.type == 'city'">
          <strong>{{ location.name }}</strong>
          {{ get_location_details(location) }}
        </div>
        <div v-if="location.type == 'dpt'">
          <strong>{{ location.name }}</strong>
          (dpt)
        </div>
      </template>
      <template slot="no-data" slot-scope="{ item: location }">
        <div>Saississez un département ou une commune</div>
      </template>
    </cool-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CoolSelect } from "vue-cool-select";
export default {
  components: { CoolSelect },
  data: () => ({
    geo: {
      selected: null,
      loading: false
    }
  }),
  computed: {
    ...mapGetters(["filters", "geo_items"]),
    selected_location: {
      get() {
        return this.filters.location;
      },
      set(newValue) {
        return this.$store.dispatch("set_filter", { location: newValue });
      }
    }
  },
  methods: {
    async onGeoSearch(search) {
      const lettersLimit = 2;
      if (search.length < lettersLimit) {
        this.geo.loading = false;
        return;
      }
      this.geo.loading = true;
      if (search.match(/\d+/g)) {
        // search by departement code, insee code
        this.$store.dispatch("search_geo_areas_by_number", { text: search });
      } else {
        this.$store.dispatch("search_geo_areas_by_name", { text: search });
      }
      this.geo.loading = false;
    },
    onGeoSelect(city) {
      this.$gtm.trackEvent({
				category: 'Search',
				action: 'Geolocation',
				label: 'Département, Commune',
				value: city
      });
      
      console.log("disable all filters");
      this.$store.dispatch("set_filter", { region: "" });
      console.log("searching on", this.selected_location.name);
      this.$store.dispatch("load_projects");
    },
    get_location_details(location) {
      // if (location.name.indexOf('arr.') > 0) {
      // 	// name contains "arr." == "arrondissement"
      // 	return`(${location.insee_id})`
      // }
      // console.log(location)
      let result = `(${location.insee_id})`;
      // console.log(result);
      return result;
    }
  }
};
</script>

<style lang="stylus">
.c-map-search-field
    width 300px
    max-width 100%
    .IZ-select
        &.small
            .IZ-select__input
                width 140px
        .IZ-select__input
            height 46px
            width 100%
            border none
            border-radius radius
            appearance none
            box-shadow: 0 1px 5px rgba(0,0,0,0.5)
            input
                font-size 1.3rem
                padding 0 14px
        .IZ-select__menu
            .IZ-select__item
                white-space nowrap
                &.IZ-select__item--selected
                    background-color red !important
                    color #fff !important
                strong
                    font-weight 500
</style>
